'use client'

import { createContext } from 'react'

import { UserBalanceModel } from '@marketplace-web/escrow-pricing/escrow-pricing-data'

export type UserBalanceContextType = {
  userBalance?: UserBalanceModel | null
}

const UserBalanceContext = createContext<UserBalanceContextType>({ userBalance: null })

export default UserBalanceContext
